import { setContext, getContext } from "svelte";
import type { GlossaryCopy, GlossaryGroup, GlossaryTerm } from "./glossary.types";

const GLOSSARY_CONTEXT_KEY = "GlossaryContext";

class GlossaryState {
	open = $state(false);
	readonly terms: GlossaryTerm[];
	readonly groups: GlossaryGroup[];
	readonly copy: GlossaryCopy;

	constructor(input: { terms: GlossaryTerm[]; groups: GlossaryGroup[]; copy: GlossaryCopy }) {
		this.terms = input.terms;
		this.groups = input.groups;
		this.copy = input.copy;
	}

	find(key: string): GlossaryTerm | undefined {
		return this.terms.find((entry) => entry.key === key);
	}

	termsInGroup(group: string): GlossaryTerm[] {
		return this.terms
			.filter((entry) => entry.group === group)
			.sort((a, b) => a.term.localeCompare(b.term));
	}
}

export function setGlossaryContext(input: {
	terms: GlossaryTerm[];
	groups: GlossaryGroup[];
	copy: GlossaryCopy;
}) {
	return setContext(GLOSSARY_CONTEXT_KEY, new GlossaryState(input));
}

export function getGlossaryContext(): GlossaryState {
	return getContext<GlossaryState>(GLOSSARY_CONTEXT_KEY);
}
